<template>
  <div style="overflow-y: auto;height: 87vh;overflow-x: hidden;">
    <h4
      class="ml-4"
      style="float: left"
    >Add Employee Information​</h4>
    <br />
    <hr />
    <div>
      <div class="text-left">
        <b-row>
          <b-col
            class="mt-3"
            cols="8"
            offset="2"
          >
            <b-form-group
              class="mt-3"
              label-cols-md="3"
              label-align-lg="right"
            >
              <template #label>
                First Name:<span class="text-danger">*</span>
              </template>
              <b-form-input
                v-model="$v.form.firstName.$model"
                :state="$v.form.firstName.$dirty ? !$v.form.firstName.$error : null"
                type="text"
              ></b-form-input>
              <b-form-invalid-feedback>{{ !$v.form.firstName.noXss ? $t( "createProfile.invalidInputMessage" ) : "This Field is required." }}</b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              class="mt-3"
              label-cols-md="3"
              label-align-lg="right"
            >
              <template #label>
                Last Name:<span class="text-danger">*</span>
              </template>
              <b-form-input
                v-model="$v.form.lastName.$model"
                :state="$v.form.lastName.$dirty ? !$v.form.lastName.$error : null"
                type="text"
              ></b-form-input>
              <b-form-invalid-feedback>{{ !$v.form.lastName.noXss ? $t( "createProfile.invalidInputMessage" ) : "This Field is required." }}</b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              class="mt-3"
              label-cols-md="3"
              label-align-lg="right"
            >
              <template #label>
                Email:<span class="text-danger">*</span>
              </template>
              <b-form-input
                v-model="$v.form.email.$model"
                :state="$v.form.email.$dirty ? !$v.form.email.$error : null"
                :class="invalidEmail ? 'existedEmailStyle' : null"
                @change="checkEmailExist($event)"
                type="email"
              ></b-form-input>
              <p
                v-if="invalidEmail"
                class="mb-0 text-feedback"
              >{{ invalidEmail }}</p>
            </b-form-group>
            <b-form-group
              label-align-lg="right"
              label-cols-md="3"
              class="mt-3"
              :state="tagFirstLevelRequiredValidatorState"
            >
              <template #label>
                1st Level Non-Compliance:<span class="text-danger">*</span>
              </template>
              <b-form-tags
                input-id="tags-basic"
                tag-variant="warning"
                tag-pills
                :input-attrs="{ 'aria-describedby': 'tags-validation-help' }"
                :tag-validator="tagValidatorFirst"
                @tag-state="tagFirstEvent"
                :state="tagFirstLevelEmailValidatorState == null ? tagFirstLevelRequiredValidatorState : tagFirstLevelEmailValidatorState"
                v-model="form.firstLevelNonCompilanceValue"
                invalidTagText="Please enter a valid email"
                placeholder="Add Email Tags"
                @input="onInputFirstLevelEmailTag"
              ></b-form-tags>
              <template
                #invalid-feedback
                v-if="tagFirstLevelEmailValidatorState == null"
              >
                <p>This Field is Required</p>
              </template>
            </b-form-group>
            <b-form-group
              label-align-lg="right"
              label-cols-md="3"
              class="mt-3"
              :state="tagSecondLevelRequiredValidatorState"
            >
              <template #label>
                2nd Level Non-Compliance:<span class="text-danger">*</span>
              </template>
              <b-form-tags
                input-id="tags-basic"
                tag-variant="warning"
                tag-pills
                :input-attrs="{ 'aria-describedby': 'tags-validation-help' }"
                :tag-validator="tagValidatorSecond"
                @tag-state="tagSecondEvent"
                :state="tagSecondLevelEmailValidatorState == null ? tagSecondLevelRequiredValidatorState : tagSecondLevelEmailValidatorState"
                v-model="form.secondLevelNonCompilanceValue"
                invalidTagText="Please enter a valid email"
                placeholder="Add Email Tags"
                @input="onInputSecondLevelEmailTag"
              ></b-form-tags>
              <template
                #invalid-feedback
                v-if="tagSecondLevelEmailValidatorState == null"
              >
                <p>This Field is Required</p>
              </template>
            </b-form-group>
            <b-form-group
              class="mt-3"
              label-cols-md="3"
              label="Date of Joining:"
              label-align-lg="right"
            >
              <b-form-datepicker
                v-model="form.doj"
                locale="en"
                placeholder="Choose a date of joining"
              ></b-form-datepicker>
            </b-form-group>
            <b-form-group
              class="mt-3"
              label-cols-md="3"
              label-align-lg="right"
            >
              <template #label>
                Division/Business Unit:<span class="text-danger">*</span>
              </template>
              <multiselect
                :maxHeight="220"
                label="text"
                track-by="value"
                v-model="$v.form.department.$model"
                :state="$v.form.department.$dirty ? !$v.form.department.$error : null"
                :options="departmentsOptions"
                :class="$v.form.department.$error ? 'border border-danger rounded' : ''"
              >
              </multiselect>
            </b-form-group>
            <b-form-group
              class="mt-3"
              label-cols-md="3"
              label="Country of Residence:"
              label-align-lg="right"
            >
              <multiselect
                :maxHeight="220"
                v-model="form.country"
                label="text"
                track-by="value"
                :options="countryOptions"
              >
              </multiselect>
            </b-form-group>
            <b-form-group
              class="mt-3"
              label-cols-md="3"
              label="Preferred Language:"
              label-align-lg="right"
            >
              <!-- style="float: left; width: 65%" -->
              <b-form-select
                v-model="form.preferredLanguage"
                :options="languageOptions"
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <div style="text-align-last: center;">
          <b-button
            class="mt-3"
            :disabled="submiting"
            @click="checkValidation"
            variant="outline-success"
            style="padding: 12px;color: white;background: #3ddc97;width: 86px;            "
          >Save
          </b-button>
        </div>
      </div>
      <b-row style="justify-content: center">
        <b-col cols="8">
          <BulkUploadComponent />
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import "moment/locale/es";
import { HTTP } from "../../../utils/HTTP";
import { Helper, Validate } from "../../../helpers";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import BulkUploadComponent from "./bulkUploadComponent.vue";
// import Templates from '../../templates.vue';
// import Datepicker from "vuejs-datepicker";

const noXss = ( value ) => Validate.noXSS( value );

export default {
  name: "AddEmployeeModal",
  mixins: [validationMixin],
  components: {
    BulkUploadComponent,
    // Templates,
    // Datepicker,
  },
  data () {
    return {
      showModal: false,
      divisionOptions: [
        { value: null, text: "Select Division..." },
        { value: "credit", text: "Credit" },
        { value: "debit", text: "Debit" },
      ],
      languageOptions: [],
      countryOptions: [],
      departmentsOptions: [],
      employeeRolesOptions: [],
      form: {
        firstName: null,
        lastName: null,
        doj: null,
        email: null,
        country: null,
        preferredLanguage: 1,
        department: null,
        firstLevelNonCompilanceValue: [],
        secondLevelNonCompilanceValue: [],
      },
      submiting: false,
      responseSuccess: false,
      invalidEmail: null,
      tagFirstLevelEmailValidatorState: null,
      tagFirstLevelRequiredValidatorState: null,
      tagSecondLevelEmailValidatorState: null,
      tagSecondLevelRequiredValidatorState: null,
    };
  },
  computed: {},
  mounted () {
    this.getEmployeeLanguages();
    this.getEmployeeCountry();
    this.getDepartmentsList();
  },
  validations: {
    form: {
      firstName: {
        required,
        noXss,
      },
      lastName: {
        required,
        noXss,
      },
      email: {
        email,
        required
      },
      department: {
        required
      },
      // firstLevelNonCompilanceValue: {
      //   required
      // },
      // secondLevelNonCompilanceValue: {
      //   required
      // }
    },
  },
  methods: {
    tagFirstEvent ( valid, invalid, duplicate ) {
      if ( invalid.length == 0 ) {
        this.tagFirstLevelEmailValidatorState = null;
      }
    },
    tagSecondEvent ( valid, invalid, duplicate ) {
      if ( invalid.length == 0 ) {
        this.tagSecondLevelEmailValidatorState = null;
      }
    },
    tagValidatorFirst ( value ) {
      let mailformat = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      // Individual tag validator function

      if ( mailformat.test( String( value ).toLowerCase() ) ) {
        this.tagFirstLevelEmailValidatorState = null;
        return true;
      } else {
        this.tagFirstLevelEmailValidatorState = false;
        return false;
      }
    },
    onInputFirstLevelEmailTag ( value ) {
      if ( value.length == 0 && this.tagFirstLevelEmailValidatorState == null ) {
        this.tagFirstLevelRequiredValidatorState = false;
      } else {
        this.tagFirstLevelRequiredValidatorState = null;
      }
    },
    tagValidatorSecond ( value ) {
      let mailformat = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      // Individual tag validator function

      if ( mailformat.test( String( value ).toLowerCase() ) ) {
        this.tagSecondLevelEmailValidatorState = null;
        return true;
      } else {
        this.tagSecondLevelEmailValidatorState = false;
        return false;
      }
    },
    onInputSecondLevelEmailTag ( value ) {
      if ( value.length == 0 && this.tagSecondLevelEmailValidatorState == null ) {
        this.tagSecondLevelRequiredValidatorState = false;
      } else {
        this.tagSecondLevelRequiredValidatorState = null;
      }
    },
    async getEmployeeLanguages () {
      this.languageOptions = [];
      this.isLoading = true;
      try {
        let result = await HTTP( "get", "api/v1/constants/languages-list", null );
        this.languageOptions = result.data.employeeLanuages;

        this.isLoading = false;
      } catch ( error ) {
        this.isLoading = false;
      }
    },
    formatDate ( value ) {
      if ( value ) {
        moment.locale( "en" );
        return moment( String( value ) ).format( "DD/MM/YYYY" );
      }
    },
    async getEmployeeCountry () {
      this.countryOptions = [];
      this.isLoading = true;
      try {
        let result = await HTTP( "get", "api/v1/constants/country-list", null );
        this.countryOptions = result.data.employeeCountry;
        this.isLoading = false;
      } catch ( error ) {
        this.isLoading = false;
      }
    },
    async getDepartmentsList () {
      this.departmentsOptions = [];
      this.isLoading = true;
      try {
        let result = await HTTP(
          "get",
          "api/v1/constants/departments-list",
          null
        );
        this.departmentsOptions = result.data.departments;
        this.isLoading = false;
      } catch ( error ) {
        this.isLoading = false;
      }
      // // console.log(this.departmentsOptions,"departmentsOptions")
    },
    async getEmployeeRoles () {
      this.employeeRolesOptions = [];
      this.isLoading = true;
      try {
        let result = await HTTP( "get", "api/v1/constants/roles", null );
        this.employeeRolesOptions = result.data.employeeRoles;
        this.isLoading = false;
      } catch ( error ) {
        this.isLoading = false;
      }
    },

    async checkEmailExist ( value ) {
      let formData = {
        email: value,
        user_id: localStorage.getItem( "userId" ),
      };
      let result = HTTP( "post", "api/v1/employees/check-exist-email", formData );

      return result
        .then( ( response ) => {
          if ( response.data.email == value ) {
            this.invalidEmail =
              "This Email Already Exist Please Change Email Address";
          } else if ( response.data === [] ) {
            return "";
          } else {
            this.invalidEmail = null;
          }
        } )
        .catch( ( error ) => {
          return [error];
        } );
    },

    resetForm () {
      this.form = {
        firstName: null,
        lastName: null,
        doj: null,
        email: null,
        country: null,
        preferredLanguage: 1,
        department: 'Consultant',
        firstLevelNonCompilanceValue: [],
        secondLevelNonCompilanceValue: [],
      };
      // this.tagFirstLevelEmailValidatorState= null
      // this.tagFirstLevelRequiredValidatorState =null
      // this.tagSecondLevelEmailValidatorState = null
      // this.tagSecondLevelRequiredValidatorState = null
      this.$v.$reset();
    },

    checkValidation () {
      if ( this.form.firstLevelNonCompilanceValue.length == 0 ) {
        // this.tagFirstLevelEmailValidatorState = null;
        this.tagFirstLevelRequiredValidatorState = false;
      } else {
        this.tagFirstLevelRequiredValidatorState = null;
      }
      if ( this.form.secondLevelNonCompilanceValue.length == 0 ) {
        // this.tagSecondLevelEmailValidatorState = null;
        this.tagSecondLevelRequiredValidatorState = false;
      } else {
        this.tagSecondLevelRequiredValidatorState = null;

      }

      this.$v.form.$touch();
      if ( this.$v.form.$anyError ) {
        return;
      } else {
        if ( this.invalidEmail ) {
          return;
        } else {
          if ( this.tagFirstLevelRequiredValidatorState == null && this.tagSecondLevelRequiredValidatorState == null
            && this.tagFirstLevelEmailValidatorState == null && this.tagSecondLevelEmailValidatorState == null ) {
            this.saveEmployee();
          }
        }
      }
    },
    makeToster ( tosterVarient, tosterMsg ) {
      this.resetForm();
      Helper.makeToast( this.$bvToast, tosterVarient, tosterMsg );
    },
    async saveEmployee () {
      let formData = {
        first_name: this.form.firstName,
        last_name: this.form.lastName,
        email: this.form.email,
        is_governance: 1,
        employee_email: this.form.email,
        date_of_joining: this.form.doj,
        employee_country_id: this.form.country ? this.form.country.value : null,
        employee_language_id: this.form.preferredLanguage,
        department_id: this.form.department ? this.form.department.value : null,
        meta_data: {
          compliance_emails: {
            first_level: this.form.firstLevelNonCompilanceValue,
            second_level: this.form.secondLevelNonCompilanceValue

          }
        },
        // is_governance: this.form.isGovernance ? 1 : 0,
        userId: localStorage.getItem( "userId" ),
        user_id: localStorage.getItem( "userId" ),
      };
      try {
        this.submiting = true;
        this.isLoading = true;
        let result = await HTTP( "post", "api/v1/employees/create", formData );
        if ( result.data && result.data.success == 1 ) {
          this.makeToster(
            "success",
            "Employee information successfully added. Compliance forms successfully sent to employee’s email address."
          );
        }
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = true;
      } catch ( err ) {
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = false;
        return [err];
      }
    },
  },
};
</script>
<style scoped>
.existedEmailStyle {
  border-color: #e71d36 !important;
  padding-right: calc(1.5em + 0.75rem) !important;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e") !important;
  background-repeat: no-repeat !important;
  background-position: right calc(0.375em + 0.1875rem) center !important;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem) !important;
}
.existedEmailStyle:focus {
  border-color: #e71d36 !important;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
}
</style>